import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIDataModel } from "../../uicomponent";
import { UIComponentCSSStyle } from "../../uicomponentcss";
import { UIComponentView } from "../../uicomponentview";
import { SelectComponent } from "../selectcomponent";
import { ProfileTuneSelectCSSStyleImpl } from "./profiletuneselectcss";
import { ProfileTuneSelectViewImpl } from "./profiletuneselectview";





export class ProfileTuneSelectComponent extends SelectComponent
{
   

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ProfileTuneSelectViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ProfileTuneSelectCSSStyleImpl(applicationContext);
    }

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/select/profiletuneselect/profiletuneselectcomponent.tsx